// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"73d71f09","488":"e619a160","560":"1c7203ac"}[chunkId] + ".chunk.js";
};